const routes = [
  {
    dividerTitle: "Globales",
  },
  {
    path: "/clasdiag",
    name: "Clasificación de Diagnósticos",
    component: () => import("@/views/forms/ClasDiag.vue"),
  },
  {
    path: "/claselem",
    name: "Clasificación de Elementos",
    component: () => import("@/views/forms/ClasElem.vue"),
  },
  {
    path: "/servicio",
    name: "Servicios",
    component: () => import("@/views/forms/Servicio.vue"),
    meta: { title: "Servicios" },
  },
  {
    path: "/diagnostico",
    name: "Diagnósticos",
    component: () => import("@/views/forms/Diagnostico.vue"),
    meta: { title: "Diagnósticos" },
  },
  {
    path: "/elemento",
    name: "Elementos",
    component: () => import("@/views/forms/Elemento.vue"),
    meta: { title: "Elementos" },
  },
  {
    path: "/especialidad",
    name: "Especialidades",
    component: () => import("@/views/forms/Especialidad.vue"),
    meta: { title: "Especialidades" },
  },
  {
    path: "/localidad",
    name: "Localidades",
    component: () => import("@/views/forms/Localidad.vue"),
  },  
  {
    path: "/elemexam",
    name: "Examen - TPSNS",
    component: () => import("@/views/forms/ElemExam.vue"),
    meta: { title: "Formularios y TPSNS" },
  },
  {
    path: "/semana",
    name: "Semanas",
    component: () => import("@/views/forms/Semana.vue"),
    meta: { title: "Semanas" },
  },  
  {
    dividerTitle: "Locales",
  },
  {
    path: "/prestador",
    name: "Prestador",
    component: () => import("@/views/forms/Prestador.vue"),
    meta: { title: "Prestadores" },
  },
  {
    path: "/plantilla",
    name: "Plantillas",
    component: () => import("@/views/forms/Plantilla.vue"),
    meta: { title: "Plantillas" },
  },
  {
    path: "/observacion",
    name: "Observaciones",
    component: () => import("@/views/forms/Observacion.vue"),
    meta: { title: "Observaciones" },
  },
  {
    path: "/respuesta",
    name: "Respuestas",
    component: () => import("@/views/forms/Respuesta.vue"),
    meta: { title: "Respuestas" },
  },
  {
    path: "/elemento-restriccion",
    name: "ElementoRestriccion",
    component: () => import("@/views/forms/ElementoRestriccion.vue"),
    meta: { title: "Restricciones de códigos" },
  },
/*  
  {
    path: "/usuario",
    name: "Usuarios",
    component: () => import("@/views/forms/Usuario.vue"),
  },
*/  
/*
  {
    path: "/persona",
    name: "Personas",
    component: () => import("@/views/forms/Persona.vue"),
  },
*/
];

export { routes };
